import Enum from '@/modules/core/app/helpers/Enum';
import { ModelType } from '@/modules/core/app/constants/ModelType';

export class EstateDetailEvent extends Enum {
  static SCROLL_COMMENTS = 'EstateDetailEvent:SCROLL_COMMENTS';
  static SCROLL_MESSAGES = 'EstateDetailEvent:SCROLL_MESSAGES';
  static ENTITY_CHANGED = 'EstateDetailEvent:ENTITY_CHANGED';
  static TASK_DELETED = 'EstateDetailEvent:TASK_DELETED';
  static ENTITY_ADDED = 'EstateDetailEvent:ENTITY_ADDED:{model}';
  static ENTITY_UPDATED = 'EstateDetailEvent:ENTITY_UPDATED:{model}';
  static ENTITY_DELETED = 'EstateDetailEvent:ENTITY_DELETED:{model}';
  static STEP_SAVED = 'EstateDetailEvent:STEP_SAVED';
  static COLLAPSE_TAB_CHANGED = 'EstateDetailEvent:COLLAPSE_TAB_CHANGED';
  static BLINK_TAB = 'EstateDetailEvent:BLINK_TAB';

  static formatEntityUpdatedModel(modelType: ModelType): string {
    return EstateDetailEvent.ENTITY_UPDATED.replace('{model}', modelType);
  }

  static formatEntityAddedModel(modelType: ModelType): string {
    return EstateDetailEvent.ENTITY_ADDED.replace('{model}', modelType);
  }

  static formatEntityDeletedModel(modelType: ModelType): string {
    return EstateDetailEvent.ENTITY_DELETED.replace('{model}', modelType);
  }
}
